@if (betslipState$ | async; as betslipState) {
    @if (showBalanceAndDeposit) {
        <div>
            <div class="betslip-deposit" (click)="goToDeposit()">
                <span>{{ siteCore.betslip.messages.Deposit }}</span>
            </div>
            <div class="betslip-user-account-balance">
                <span class="text">{{ siteCore.betslip.messages.Balance }}</span>
                <span class="value">{{ accountBalance | bsCurrency: true }}</span>
            </div>
        </div>
    }

    @if (showDisplayModeSwitcher) {
        <bs-betslip-display-mode-toggle [displayMode]="betslipState.displayMode" (setDisplayMode)="setDisplayMode($event)" />
    }

    @if (inColumn || !betslipConfig.isBalanceHeaderEnabled) {
        <bs-wallet-type-container trackingPosition="BetSlip" [inColumn]="inColumn" />
    }
    @switch (betslipState.displayMode) {
        @case ('Tabbed') {
            <div class="betslip__content">
                @switch (betslipState.stage) {
                    @case (BetslipStage.Empty) {
                        <ng-container *ngTemplateOutlet="emptyState" />
                    }
                    @case (BetslipStage.Edit) {
                        @if (oddsDisplayFormat$ | async; as oddsDisplayFormat) {
                            <bs-betslip-edit-state
                                [inColumn]="inColumn"
                                [oddsDisplayFormat]="oddsDisplayFormat"
                                [isUserOnPlayBreak]="isUserOnPlayBreak"
                                [profileData$]="profileDetails$"
                                [hasArcPreBetMessage$]="hasArcPreBetMessage$" />
                        }
                    }
                    @case (BetslipStage.Result) {
                        @if (oddsDisplayFormat$ | async; as oddsDisplayFormat) {
                            <bs-digital-result-state [inColumn]="inColumn" [oddsDisplayFormat]="oddsDisplayFormat" />
                        }
                    }
                }
            </div>
        }
        @case ('Linear') {
            @switch (betslipState.stage) {
                @case (BetslipStage.Empty) {
                    <ng-container *ngTemplateOutlet="emptyState" />
                }
                @case (BetslipStage.Edit) {
                    @if (oddsDisplayFormat$ | async; as oddsDisplayFormat) {
                        <bs-betslip-linear-edit-state
                            class="display-mode-linear"
                            [oddsDisplayFormat]="oddsDisplayFormat"
                            [isUserOnPlayBreak]="isUserOnPlayBreak"
                            [profileData$]="profileDetails$"
                            [hasArcPreBetMessage$]="hasArcPreBetMessage$"
                            [inColumn]="inColumn" />
                    }
                }
                @case (BetslipStage.Result) {
                    @if (oddsDisplayFormat$ | async; as oddsDisplayFormat) {
                        <bs-digital-result-state [isLinear]="true" [inColumn]="inColumn" [oddsDisplayFormat]="oddsDisplayFormat" />
                    }
                }
            }
        }
    }

    <bs-digital-over-ask />
}

<ng-template #emptyState>
    @if (!isUserOnPlayBreak) {
        <bs-digital-empty-state [inColumn]="inColumn" />
    }
    <div [ngClass]="{ 'arc-betslip-message': !isUserOnPlayBreak }">
        <ms-arc-message [profileData]="(profileDetails$ | async) ?? undefined" [featureLocation]="featureLocation.PreBetSlipMessage" />
    </div>
</ng-template>
